import { render, staticRenderFns } from "./messagesHistory.vue?vue&type=template&id=14fc9b4a&"
import script from "./messagesHistory.vue?vue&type=script&lang=js&"
export * from "./messagesHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports